import "slick-carousel";
import jQuery from "jquery";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import $ from "jquery";
window.jQuery = $;

if ($(".news_detail_ct").length > 0) {
  $(".news_detail_ct").find("table").wrap("<div class='table_scroll' />");
}
if ($(window).width() < 992) {
  if ($(".project_detail_slider").length > 0) {
    $(".project_detail_slider").slick({
      autoplaySpeed: 5000,
      dots: false,
      arrows: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      //centerMode: true,
      centerPadding: "0px",
      variableWidth: true,
    });
  }
} else {
  if ($(".career_detail_gr02").length > 0) {
    var _offset1 = $(".career_detail_gr02").offset().top;
    $(window).on("scroll", function () {
      var topPos1 = $(this).scrollTop() + 100;
      $(".form_gr.fixed").css("top", topPos1 - 150);
      if (topPos1 > _offset1) {
        $(".form_gr").addClass("fixed");
      } else {
        $(".form_gr").removeClass("fixed");
      }
    });
  }
}

if ($(".heading_show").length > 0) {
  $(".heading_show").on("click", function () {
    $(this).toggleClass("show");
    $(this).next(".group_show").slideToggle();
  });
}

if ($(".form-file").length > 0) {
  // no react or anything
  let state = {};
  // state management
  function updateState(newState) {
    state = { ...state, ...newState };
  }
  // event handlers
  $(".form-file").each(function () {
    let selector = $(this);
    $(this)
      .find("input")
      .change(function (e) {
        let files = $(this)[0].files;
        let filesArr = Array.from(files);
        updateState({ files: files, filesArr: filesArr });
        renderFileList(selector);
      });
    $(this)
      .find(".files")
      .on("click", ".item > .item-delete", function (e) {
        let key = $(this).parent().attr("key");
        let curArr = state.filesArr;
        curArr.splice(key, 1);
        updateState({ filesArr: curArr });
        renderFileList(selector);
      });
  });

  // render functions
  function renderFileList(element) {
    let fileMap = state.filesArr.map((file, index) => {
      let suffix = "bytes";
      let size = file.size;
      if (size >= 1024 && size < 1024000) {
        suffix = "KB";
        size = Math.round((size / 1024) * 100) / 100;
      } else if (size >= 1024000) {
        suffix = "MB";
        size = Math.round((size / 1024000) * 100) / 100;
      }
      let src = "/wp-content/uploads/2023/11/icon-carrer01.svg";
      return `<div class="item" key="${index}">
              <div class="item-description">
                  <img class="object-contain rounded-5px item-image" width="20" src="${src}"/>
                  <div class="ms-15px item-title">
                      ${file.name}
                  </div>
              </div>
              <div class="item-delete">
                  <img
                      class="object-contain"
                      width="12"
                      src="/wp-content/uploads/2023/11/close.svg"
                  />
              </div>
          </div>`;
    });
    $(element).find(".preview").html(fileMap);
  }
}

if ($(".btn-scroll").length > 0) {
  var _offset = $("#career_form").offset().top;
  $(window).on("scroll", function () {
    var topPos = $(this).scrollTop() + 400;
    if (topPos > _offset) {
      $(".btn-scroll").addClass("d-none");
    } else {
      $(".btn-scroll").removeClass("d-none");
    }
  });
  $("#btn-scroll").on("click", function (event) {
    event.preventDefault();
    var _valueTop = $($(this).attr("href")).offset().top - 70;
    $("html, body").animate({ scrollTop: _valueTop }, 300);
    return false;
  });
}
